module.exports = __webpack_public_path__ + "static/img/scholarcy.8a1d754e.png";